"use client";

import { useQuery } from "@tanstack/react-query";
import { useContext, useState, useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { personOrganizationSearchOptions } from "@/queryOptions/persons";
import { FilterParamsContext } from "@/stories/SearchDrawerComponents/FilterParamsProvider";

export default function SpeakerOrganizationSelect() {
  const { filterParams, setFilterParams } = useContext(FilterParamsContext);
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");

  const { data: organizations, isLoading } = useQuery(
    personOrganizationSearchOptions(debouncedInputValue),
  );

  // Debounce the input value
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue]);

  return (
    <Autocomplete
      multiple
      freeSolo
      options={
        organizations
          ? [
              inputValue,
              ...(organizations.result_examples.filter(
                (example) => example !== inputValue,
              ) ?? []),
            ]
          : []
      }
      value={filterParams.organization_search_terms ?? []}
      onChange={(_event, newValue) => {
        setFilterParams({
          ...filterParams,
          organization_search_terms: newValue,
        });
      }}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue, reason) => {
        // Only clear input when user explicitly clears it, not when selecting options
        if (reason !== "selectOption") {
          setInputValue(newInputValue);
        }
      }}
      getOptionLabel={(option) => {
        if (option === inputValue) {
          return `${option} - ${organizations?.result_count} matching organization${organizations?.result_count === 1 ? "" : "s"}`;
        }
        return option;
      }}
      getOptionKey={(option) => option}
      renderInput={(params) => <TextField {...params} label="Organization" />}
      loading={isLoading}
      disableCloseOnSelect
      clearOnBlur={false}
      filterOptions={(x) => x} // Disable built-in filtering since we're using API search
    />
  );
}
